import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { Box, Chip, Fab, IconButton, Modal, Tab, Tabs, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "src/shared/hooks/useForm";
import { ErrorComponent } from "src/shared/pages/error";
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { AddRequirementsInLocation } from "src/stateManagement/redux/slices/location/asyncReducers";
import { Requirements } from "./components/requirements/Requirements";
import { HeaderAddActivity } from "./header/HeaderAddRequirements";
import Swal from "sweetalert2";
import '../requirementsStyles.scss'
import { statusConditions } from "src/shared/mocks/variables";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface Props {
    show: any;
    setShowPendingActivities: any;
    TabDisable: boolean;
    activeActivity?: ActiveActivityDto;
    setActiveActivity?: any;
}

export interface ActiveActivityDto {
    optimizationActivityId: string;
    requirements: RequirementDto[];
    requiredUserId: string;
    requiredDate: Date;
    originFieldActivityId: string;

}

export interface RequirementDto {
    id: string;
    location: string;
    name: string;
    value: any;
    type: string;
    comments: string;
    blocker: any[];
    status: string;
    simulationDate?: string;
    lastProduction?: string;
    targetProduction?: string;
    isWellWithMultiplesTDSEntries?: boolean;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export const AddActivity = ({
    show,
    setShowPendingActivities,
    TabDisable,
    activeActivity,
    setActiveActivity,
}: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [value, setValue] = useState(0);
    const [open, setOpen] = useState(false);
    const [requirements, setRequeriments] = useState<any>([]);

    const { locationId, projectId, lastStatusConditions } = useSelector(
        (state) => state.location
    );

    const [errors, setErrors] = useState<string[]>([])

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleShowPendingActivities = (): void => {
        setShowPendingActivities(!show);
    };

    const handleOpen = () => setOpen(true);

    const [formValues, handleInputChange, reset, setNuewValues] = useForm({
        optimizationActivityId: undefined,
        requiredDate: moment().format("YYYY-MM-DD"),
        requiredUserId: "",
        locationId: locationId,
        projectId: projectId,
        type: "Optimization",
        status: "pending",
        originFieldActivityId:undefined,
        simulationDate: undefined,
        lastProduction: undefined,
        targetProduction: undefined,
    });

    const { requiredUserId, originFieldActivityId } = formValues;

    useEffect(() => {
        if (activeActivity) {
            const { requiredUserId, requiredDate, optimizationActivityId, originFieldActivityId } = activeActivity;

            const requirements: RequirementDto[] = activeActivity.requirements.map((item) => ({
                id: item.id,
                location: item.location,
                name: item.name,
                value: item.value,
                type: item.type,
                comments: item.comments,
                blocker: item.blocker,
                status: item.status,
                simulationDate: item.simulationDate,
                lastProduction: item.lastProduction,
                targetProduction: item.targetProduction,
                isWellWithMultiplesTDSEntries: item.isWellWithMultiplesTDSEntries,
            }));

            setRequeriments(requirements);
            setNuewValues({
                optimizationActivityId: optimizationActivityId,
                requiredDate: moment(requiredDate).format("YYYY-MM-DD"),
                requiredUserId: requiredUserId,
                locationId: locationId,
                projectId: projectId,
                type: "Optimization",
                status: "pending",
                originFieldActivityId,
            });
        }
    }, [activeActivity])

    const handleSubmit = () => {
        const data = {
            ...formValues,
            requirements,
        };

        const errors = []

        let messageWithErrors = []

        if (!requiredUserId) {
            errors.push("requiredUserId")
            messageWithErrors.push("El campo requerido por es obligatorio")
        }

        if (!originFieldActivityId){
            errors.push("originFieldActivityId")
            messageWithErrors.push("El campo Actividad asociada es obligatorio")
        }

        if (requirements.length === 0) {
            errors.push("requirements")
            messageWithErrors.push("Debe agregar al menos un requerimiento")
        }

        setErrors(errors)
        if (errors.length > 0) {
            Swal.fire({
                title: "Error",
                html: `<p>No se puede agregar debido a los siguientes errores:</p><ul>${messageWithErrors.map(error => `<li>${error}</li>`).join('')}</ul>`,
                icon: "error",
                confirmButtonText: "Aceptar",
            })
            return
        }

        dispatch(AddRequirementsInLocation(data));
        setActiveActivity(undefined);
        setShowPendingActivities(false);
    };

    return (
        <Modal
            open={true}
            onClose={() => { }}
        >
            <Box sx={{
                backgroundColor: "#fff",
                height: '100vh',
                overflowY: "scroll",
                padding: "20px",
            }}>
                <Box
                    sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
                >
                    <IconButton
                        aria-label="delete"
                        onClick={handleShowPendingActivities}
                        sx={{
                            backgroundColor: "#03365e",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#129ED3",
                            },
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Box>
                        <Typography variant="h5" color="initial">
                            Agregar Actividad de Optimización
                        </Typography>
                    </Box>
                    <IconButton
                        aria-label="delete"
                        onClick={handleSubmit}
                        sx={{
                            backgroundColor: "#03365e",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "#129ED3",
                            },
                        }}
                    >
                        <SaveOutlinedIcon />
                    </IconButton>
                </Box>

                <Box sx={{ width: "100%" }}>
                    <Grid container spacing={2} sx={{ padding: "10px 50px" }}>
                        <Grid size={12}>
                            <HeaderAddActivity
                                TabDisable={TabDisable}
                                formValues={formValues}
                                handleInputChange={handleInputChange}
                                elementsWithErrors={errors}
                            />
                        </Grid>
                        {/* tabs */}
                        <Grid size={12} sx={{ mt: 4 }}>
                            <Box>
                                {/* Tabs */}
                                <Box
                                    sx={{
                                        borderBottom: 1,
                                        borderColor: "divider",
                                    }}
                                >
                                    <Tabs value={value} onChange={handleChange}>
                                        <Tab
                                            label="Actividades"
                                            {...a11yProps(0)}
                                        />
                                        {/* <Tab
                                            label="Histórico de Cambios"
                                            {...a11yProps(1)}
                                            disabled={TabDisable}
                                        />
                                        <Tab
                                            label="Tareas Relacionadas"
                                            {...a11yProps(2)}
                                            disabled={TabDisable}
                                        />
                                        <Tab
                                            label="Chats"
                                            {...a11yProps(3)}
                                            disabled={TabDisable}
                                        /> */}
                                    </Tabs>
                                </Box>

                                <CustomTabPanel value={value} index={0}>
                                    <Requirements
                                        TabDisable={TabDisable}
                                        open={open}
                                        setOpen={setOpen}
                                        requirements={requirements}
                                        setRequeriments={setRequeriments}
                                    />
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            mt: 4,
                                        }}
                                    >
                                        <Fab
                                            size="medium"
                                            color="primary"
                                            aria-label="add"
                                            onClick={handleOpen}
                                        >
                                            <AddIcon />
                                        </Fab>
                                    </Box>
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={1}>
                                    <ErrorComponent
                                        type="403"
                                        infoPage="Modulo No disponible ......"
                                    />
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={2}>
                                    {/* <RelatedTasks /> */}
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={3}>
                                    <ErrorComponent
                                        type="403"
                                        infoPage="Modulo No disponible ......"
                                    />
                                </CustomTabPanel>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Modal>
    );
};
